import React from 'react';
import { motion } from 'framer-motion';
const tomos = [{
  num: '1',
  color: 'bg-green-500',
  bgLight: 'bg-green-50',
  title: 'Clásico Renovado',
  classes: '8+ clases',
  desc: 'Mat, respiración, core, movilidad vertebral y flexibilidad profunda.'
}, {
  num: '2',
  color: 'bg-yellow-400',
  bgLight: 'bg-yellow-50',
  title: 'Pilates Force',
  classes: '10 clases',
  desc: 'Entrenamiento con bandas elásticas y pesas livianas. Fuerza con conciencia.'
}, {
  num: '3',
  color: 'bg-orange-500',
  bgLight: 'bg-orange-50',
  title: 'Flow Dinámico',
  classes: '10 clases',
  desc: 'Transiciones fluidas y movimiento continuo. Desde el primer flow hasta 45 minutos sin pausa.'
}, {
  num: '4',
  color: 'bg-red-500',
  bgLight: 'bg-red-50',
  title: 'Elementos: Small Ball & Aro',
  classes: '10 clases',
  desc: 'Trabajo de precisión con pelota pequeña y Magic Circle. Activa lo que las manos vacías no alcanzan.'
}, {
  num: '5',
  color: 'bg-purple-500',
  bgLight: 'bg-purple-50',
  title: 'Pilates Suave',
  classes: '10 clases',
  desc: 'Protocolo de seguridad completo para adultos mayores, movilidad articular y funcionalidad.'
}, {
  num: '6',
  color: 'bg-gold',
  bgLight: 'bg-yellow-50',
  title: 'Full Power',
  classes: '10 clases',
  desc: 'El repertorio avanzado completo de Joseph Pilates y Reformer adaptado al suelo.',
  isStar: true
}];
export const TomosSection = () => {
  return <section className="py-8 md:py-14 bg-offwhite" data-id="element-383">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-384">
        <div className="text-center mb-8 md:mb-16" data-id="element-385">
          <h2 className="text-sm font-bold text-sage uppercase tracking-widest mb-2" data-id="element-386">
            Los 6 Tomos
          </h2>
          <h3 className="text-2xl md:text-5xl font-bold text-charcoal font-playfair mb-4" data-id="element-387">
            Para instructoras de Pilates de todos los niveles y enfoques
          </h3>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-8" data-id="element-388">
          {tomos.map((tomo, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className={`rounded-xl md:rounded-2xl p-5 md:p-8 border border-gray-100 shadow-sm hover:shadow-md transition-shadow relative overflow-hidden ${tomo.bgLight}`} data-id="element-389">
              <div className="flex items-center gap-3 mb-3 md:mb-6" data-id="element-390">
                <div className={`w-10 h-10 md:w-12 md:h-12 rounded-full flex items-center justify-center text-white font-bold text-lg md:text-xl shadow-inner ${tomo.color}`} data-id="element-391">
                  {tomo.isStar ? '⭐' : tomo.num}
                </div>
                <div data-id="element-392">
                  <h4 className="text-[10px] font-bold text-gray-500 uppercase tracking-wider mb-0.5" data-id="element-393">
                    TOMO {tomo.num}
                  </h4>
                  <h5 className="text-base md:text-xl font-bold text-charcoal font-playfair" data-id="element-394">
                    {tomo.title}
                  </h5>
                </div>
              </div>
              <div className="mb-2 md:mb-4" data-id="element-395">
                <span className="inline-block px-2.5 py-0.5 bg-white rounded-full text-[10px] md:text-xs font-semibold text-gray-600 shadow-sm" data-id="element-396">
                  {tomo.classes}
                </span>
              </div>
              <p className="text-sm text-gray-700 leading-relaxed" data-id="element-397">
                {tomo.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
};